
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin-top: 1.5rem;
  display: block;
  max-width: 700px;
}

@media (min-width: 640px) {

  :host {
    margin-left: auto;
    margin-right: auto;
  }
}

hr {
  border-width: 0px;
  border-bottom:1px solid var(--gray-professional-lighten-2);
}

.table-wrapper {
  margin-bottom: 2rem;
  overflow: hidden;
  border-radius: 0.375rem;
  background-color: var(--neutral-white);
  border:1px solid #e2e8f0 !important;
  border-top:none !important;
}

.logos-wrapper {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

@media (min-width: 768px) {

  .logos-wrapper {
    justify-content: flex-end;
  }
}

.idb-logo {
  height: 1.75rem;
}

.heading-wrapper {
  display: flex;
  width: 100%;
  flex-direction: column;
  flex-wrap: wrap;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

@media (min-width: 768px) {

  .heading-wrapper {
    flex-direction: row;
  }

  .heading-wrapper {
    align-items: center;
  }
}

slot[name='heading'] {
  margin-bottom: 1.75rem;
  margin-top: 1.5rem;
  max-width: 50%;
  font-weight: var(--fw-semibold);
  color: var(--blue-responsible-darken-2);
  font-size:1.5rem;
}

@media (min-width: 768px){
  slot[name='heading']{
    font-size:1.75rem;
  }
}
`;